import React from 'react';
import { Input } from '../ui/input';

// Datetime values in this app are wall-clock times at the event's location.
// The backend may append the location's UTC offset (e.g. hotel check-in), so
// both directions here must avoid Date-based timezone conversion: display
// extracts the literal date/time from the string, and saving passes the
// datetime-local value through unchanged instead of calling toISOString()
// (which would shift the time into UTC by the browser's offset).
const formatForDateTimeLocal = (dateValue) => {
  if (!dateValue || dateValue === '') return '';

  if (!(dateValue instanceof Date)) {
    const str = String(dateValue).trim();
    const withTime = str.match(/^(\d{4}-\d{2}-\d{2})[T ](\d{2}:\d{2})/);
    if (withTime) return `${withTime[1]}T${withTime[2]}`;
    const dateOnly = str.match(/^(\d{4}-\d{2}-\d{2})$/);
    if (dateOnly) return `${dateOnly[1]}T00:00`;
  }

  const date = dateValue instanceof Date ? dateValue : new Date(dateValue);
  if (isNaN(date.getTime())) return '';

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

const CustomDateTimePicker = ({
  value,
  onChange,
  className,
  minDate,
  showTimeSelect = true,
  timeIntervals = 15,
  dateFormat = "yyyy-MM-dd'T'HH:mm",
  placeholderText = "Select date and time",
  ...props
}) => {
  const handleDateTimeChange = (e) => {
    if (onChange) {
      // datetime-local already yields wall-clock "YYYY-MM-DDTHH:mm"
      onChange(e.target.value || '');
    }
  };

  return (
    <Input
      type="datetime-local"
      value={formatForDateTimeLocal(value)}
      onChange={handleDateTimeChange}
      min={formatForDateTimeLocal(minDate) || undefined}
      className={className}
      placeholder={placeholderText}
      {...props}
    />
  );
};

export default CustomDateTimePicker;
